import {features} from '../../../assets/data/homeData'

const FeaturesSection = () => (
  <section id="features" className="py-20 bg-gradient-to-b from-[#f5f6fa] to-[#e2bf9c]/10">
    <div className="max-w-7xl mx-auto px-4">
      <h2 className="text-4xl font-extrabold text-center mb-16 text-[#0a363c] tracking-tight">
        Powerful Features to Empower Your Finances
      </h2>
      <div className="flex flex-col gap-20">
        {features.map((feature, idx) => (
          <div
            key={idx}
            className={`
              flex flex-col md:flex-row items-center gap-20 
              ${idx % 2 === 1 ? "md:flex-row-reverse" : ""}
            `}
          >
            {/* Image */}
            <div className="md:w-1/2 w-full">
              <img
                src={feature.image}
                alt={feature.title}
                className="w-full h-100 object-cover rounded-2xl"
              />
            </div>

            {/* Text */}
            <div className="md:w-1/2 w-full">
              <h3 className="text-2xl md:text-3xl font-bold mb-4 text-[#0a363c]">
                {feature.title}
              </h3>
              <p className="text-[#0a363c]/80 text-lg leading-relaxed mb-4">
                {feature.description}
              </p>
              <ul className="list-disc ml-6 text-[#0a363c]/70 text-base space-y-1">
                {feature.details.map((detail, i) => (
                  <li key={i}>{detail}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesSection;
